module.exports = __webpack_public_path__ + "img/get-card.2de12dab.png";